(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ro-product-preorder"] && !Shopify.designMode) return;
  try {
    
/* FAQ Toggle */
document.querySelectorAll('[data-ro-faq-toggle]').forEach(function(btn) {
  btn.addEventListener('click', function() {
    this.parentElement.classList.toggle('ro-open');
  });
});

/* Lazy-load videos — only play when scrolled into view */
var roVideos = document.querySelectorAll('.ro-feature-video');
if (roVideos.length && 'IntersectionObserver' in window) {
  var videoObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    });
  }, { rootMargin: '200px' });
  roVideos.forEach(function(video) { videoObserver.observe(video); });
}

/* ── Buy Section: Image Carousel ── */
var roBuySlide = 0;
var roBuyTotalSlides = document.querySelectorAll('.ro-buy-carousel-slide').length;
var roBuyTouchStartX = 0;

window.roBuyGoToSlide = roBuyGoToSlide;
function roBuyGoToSlide(n) {
  roBuySlide = n;
  var track = document.getElementById('roBuyCarouselTrack');
  if (track) track.style.transform = 'translateX(-' + (n * 100) + '%)';
  document.querySelectorAll('.ro-buy-carousel-dot').forEach(function(d, i) {
    d.classList.toggle('active', i === n);
  });
}

window.roBuySetImage = roBuySetImage;
function roBuySetImage(src, thumb) {
  var mainImg = document.getElementById('ro-buy-main-img');
  if (mainImg) mainImg.src = src;
  document.querySelectorAll('.ro-buy-thumb').forEach(function(t) { t.classList.remove('active'); });
  thumb.classList.add('active');
}

/* Scrollable thumbnail strip — shift by 5 at a time */
var roBuyThumbOffset = 0;
window.roBuyScrollThumbs = roBuyScrollThumbs;
function roBuyScrollThumbs(direction) {
  var strip = document.getElementById('roBuyThumbStrip');
  if (!strip) return;
  var thumbs = strip.querySelectorAll('.ro-buy-thumb');
  var total = thumbs.length;
  var visible = 5;
  var maxOffset = Math.max(0, total - visible);
  roBuyThumbOffset = Math.min(maxOffset, Math.max(0, roBuyThumbOffset + (direction * visible)));
  /* Each thumb is calc((100% - 32px) / 5) wide + 8px gap — calculate pixel shift */
  var viewport = strip.parentElement;
  if (!viewport) return;
  var vpWidth = viewport.offsetWidth;
  var thumbWidth = (vpWidth - 32) / 5;  /* matches CSS calc */
  var shift = roBuyThumbOffset * (thumbWidth + 8);  /* 8 = gap */
  strip.style.transform = 'translateX(-' + shift + 'px)';
}

function roBuyInitCarousel() {
  var track = document.getElementById('roBuyCarouselTrack');
  if (!track) return;
  track.addEventListener('touchstart', function(e) { roBuyTouchStartX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', function(e) {
    var diff = roBuyTouchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      if (diff > 0 && roBuySlide < roBuyTotalSlides - 1) roBuyGoToSlide(roBuySlide + 1);
      if (diff < 0 && roBuySlide > 0) roBuyGoToSlide(roBuySlide - 1);
    }
  });
}
roBuyInitCarousel();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ro-product-shared"] && !Shopify.designMode) return;
  try {
    
/* FAQ Toggle */
/* ── 7-Stage toggle ── */
function roToggleStages() {
  var wrap = document.getElementById('roStagesExpand');
  var btn = document.getElementById('roStagesToggle');
  var txt = document.getElementById('roStagesToggleText');
  if (!wrap || !btn) return;
  var isOpen = wrap.classList.toggle('open');
  btn.classList.toggle('open', isOpen);
  txt.textContent = isOpen ? 'Hide filtration stages' : 'See how our 7-stage filtration system works';
}

document.querySelectorAll('[data-ro-faq-toggle]').forEach(function(btn) {
  btn.addEventListener('click', function() {
    this.parentElement.classList.toggle('ro-open');
  });
});

/* Lazy-load videos — only play when scrolled into view */
var roVideos = document.querySelectorAll('.ro-feature-video');
if (roVideos.length && 'IntersectionObserver' in window) {
  var videoObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    });
  }, { rootMargin: '200px' });
  roVideos.forEach(function(video) { videoObserver.observe(video); });
}

/* ── Buy Section: Image Carousel ── */
var roBuySlide = 0;
var roBuyTotalSlides = document.querySelectorAll('.ro-buy-carousel-slide').length;
var roBuyTouchStartX = 0;

window.roBuyGoToSlide = roBuyGoToSlide;
function roBuyGoToSlide(n) {
  roBuySlide = n;
  var track = document.getElementById('roBuyCarouselTrack');
  if (track) track.style.transform = 'translateX(-' + (n * 100) + '%)';
  document.querySelectorAll('.ro-buy-carousel-dot').forEach(function(d, i) {
    d.classList.toggle('active', i === n);
  });
}

window.roBuySetImage = roBuySetImage;
function roBuySetImage(src, thumb) {
  var mainImg = document.getElementById('ro-buy-main-img');
  if (mainImg) mainImg.src = src;
  document.querySelectorAll('.ro-buy-thumb').forEach(function(t) { t.classList.remove('active'); });
  thumb.classList.add('active');
}

/* Scrollable thumbnail strip — shift by 5 at a time */
var roBuyThumbOffset = 0;
window.roBuyScrollThumbs = roBuyScrollThumbs;
function roBuyScrollThumbs(direction) {
  var strip = document.getElementById('roBuyThumbStrip');
  if (!strip) return;
  var thumbs = strip.querySelectorAll('.ro-buy-thumb');
  var total = thumbs.length;
  var visible = 5;
  var maxOffset = Math.max(0, total - visible);
  roBuyThumbOffset = Math.min(maxOffset, Math.max(0, roBuyThumbOffset + (direction * visible)));
  /* Each thumb is calc((100% - 32px) / 5) wide + 8px gap — calculate pixel shift */
  var viewport = strip.parentElement;
  if (!viewport) return;
  var vpWidth = viewport.offsetWidth;
  var thumbWidth = (vpWidth - 32) / 5;  /* matches CSS calc */
  var shift = roBuyThumbOffset * (thumbWidth + 8);  /* 8 = gap */
  strip.style.transform = 'translateX(-' + shift + 'px)';
}

function roBuyInitCarousel() {
  var track = document.getElementById('roBuyCarouselTrack');
  if (!track) return;
  track.addEventListener('touchstart', function(e) { roBuyTouchStartX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', function(e) {
    var diff = roBuyTouchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      if (diff > 0 && roBuySlide < roBuyTotalSlides - 1) roBuyGoToSlide(roBuySlide + 1);
      if (diff < 0 && roBuySlide > 0) roBuyGoToSlide(roBuySlide - 1);
    }
  });
}
roBuyInitCarousel();

  } catch(e) { console.error(e); }
})();
})();
